import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { computed, Ref, ref } from 'vue'
import { useSeller } from '@invivodf/common/src/application/composables/useSeller'
import { getLogisticSettings, setLogisticSettings } from '../../dependency-injection'

const NATIONAL_ADMIN_ROLE = 'bo_national_administrator'

export function useShippingSettings(roles: Ref<string[]>) {
  const i18n = useI18nForVue2()
  const seller = useSeller()

  const title = `${i18n.t('ctx.parameters.toggles__logistic-offer__title')}`
  const isActive = ref<boolean>(false)
  const isDisabled = ref<boolean>(false)
  const error = ref<string | null>(null)
  const isAuthorized = computed(() => roles.value.includes(NATIONAL_ADMIN_ROLE))

  const init = async () => {
    try {
      const settings = await getLogisticSettings.execute(String(seller.value.id))
      isActive.value = settings.isShippingFree
    } catch (err) {
      isDisabled.value = true
      error.value = `${i18n.t('ctx.parameters.toggles__logistic-offer__error-init')}`
    }
  }

  const toggle = async (active: boolean) => {
    if (!isAuthorized.value) return

    isActive.value = active

    try {
      await setLogisticSettings.execute(String(seller.value.id), { isShippingFree: active })
      error.value = null
    } catch (err) {
      isActive.value = !active
      error.value = `${i18n.t('ctx.parameters.toggles__logistic-offer__error-toggle')}`
    }
  }

  return {
    title,
    isDisabled,
    isActive,
    isAuthorized,
    error,
    init,
    toggle,
  }
}
